import { render, staticRenderFns } from "./CurrentNtsCard.vue?vue&type=template&id=e2e95af0"
import script from "./CurrentNtsCard.vue?vue&type=script&lang=js"
export * from "./CurrentNtsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports